module.exports = __webpack_public_path__ + "static/img/trend-3.62cab078.png";